import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import courseModule from './modules/course'
import authModule from './modules/auth'
import enrollModule from './modules/enroll'
import semesterModule from './modules/semester'
import adminModule from './modules/admin'
import errorModule from './modules/error'
import registration from './modules/registration/index'

Vue.use(Vuex)

/*
  vuex persist is being used to save user sessions and enrollment page information if user refreshes page
  https://github.com/championswimmer/vuex-persist
*/
const vuexAuthStorage = new VuexPersist({
  key: 'eagleridge.auth',
  storage: window.sessionStorage, 
  reducer: state => ({ 
    auth: state.auth
  }),
  filter: (mutation) => mutation.type === 'setUser' || mutation.type === 'updateSession' || mutation.type === 'setToken'
})

const vuexEnrollmentStorage = new VuexPersist({
  key: 'eagleridge.student',
  storage: window.sessionStorage, 
  reducer: state => ({ 
    enrollment: state.enrollment
  }),
  filter: (mutation) => mutation.type === 'setEnrollmentStudent'
})

const store = new Vuex.Store({
  modules: {
    courseModule: courseModule,
    auth: authModule,
    enrollment: enrollModule,
    semesterModule: semesterModule,
    admin: adminModule,
    errorModule: errorModule,
    registration
  },
  plugins: [vuexAuthStorage.plugin, vuexEnrollmentStorage.plugin]
})

export default store
